// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-nav .nav-link {
  font-family: Helvetica Neue;
  color: #707070 !important;
}

.logo-container {
  font-family: Helvetica Neue;
  color: #707070;
}
.logo-container__subheader {
  font-size: 1.1rem;
}`, "",{"version":3,"sources":["webpack://./src/Screens/StepHeader/StepHeader.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,yBAAA;AACF;;AAEA;EACE,2BAAA;EACA,cAAA;AACF;AACE;EACE,iBAAA;AACJ","sourcesContent":[".navbar-nav .nav-link {\n  font-family: Helvetica Neue;\n  color: #707070 !important;\n}\n\n.logo-container {\n  font-family: Helvetica Neue;\n  color: #707070;\n\n  &__subheader {\n    font-size: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
